module.exports = __webpack_public_path__ + "static/media/driver_insurance_notupdated.6f70feb6.svg";